export default (() => {
  // if <body> contains class 'disable-odin-authenticity-token'
  if (document.body.classList.contains('disable-odin-authenticity-token')) {
    return
  }
  window.addEventListener('load', () => {
    fetch('/api/csrf.json', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
    })
      .then((res) => {
        if (!res.ok) return null
        return res.json().catch(() => null)
      })
      .then((data) => {
        if (!data?.csrf_token) return
        document.querySelectorAll('form').forEach((form) => {
          const method = (form.getAttribute('method') || 'GET').toUpperCase()
          if (method === 'GET') return
          let tokenInput = form.querySelector(
            'input[name="authenticity_token"]'
          )
          if (!tokenInput) {
            tokenInput = document.createElement('input')
            tokenInput.setAttribute('name', 'authenticity_token')
            tokenInput.setAttribute('type', 'hidden')
            form.appendChild(tokenInput)
          }
          tokenInput.value = data.csrf_token
        })
        const meta = document.querySelector('meta[name="csrf-token"]')
        if (!meta) {
          // eslint-disable-next-line no-const-assign
          meta = document.createElement('meta')
          meta.setAttribute('name', 'csrf-token')
          document.head.appendChild(meta)
        }
        meta.setAttribute('content', data.csrf_token)
      })
      .catch(() => {})
  })
})()
